import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Index from '../views/index.vue'
import Process from '../views/process.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('../views/login.vue')
  },
  {
    path: '/3D',
    name: '3D',
    meta: {
      title: '档案跟踪'
    },
    component: () => import('../views/archive/3D.vue')
  },
  {
    path: '/',
    name: 'Index',
    component: Index,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: () => import('../views/home.vue')
    },
    {
      path: 'enterprise',
      name: 'enterprise',
      meta: {
        title: '企业全景'
      },
      component: () => import('../views/enterprise.vue')
    },
    {
      path: 'enterpriseInfo',
      name: 'enterpriseInfo',
      meta: {
        title: '企业信息'
      },
      component: () => import('../views/enterprise/info.vue')
    },
    {
      path: 'enterpriseHonor',
      name: 'enterpriseHonor',
      meta: {
        title: '企业荣誉'
      },
      component: () => import('../views/enterprise/honor.vue')
    },
    {
      path: 'enterprisePartner',
      name: 'enterprisePartner',
      meta: {
        title: '合作伙伴'
      },
      component: () => import('../views/enterprise/partner.vue')
    },
    {
      path: 'enterpriseSwiper',
      name: 'enterpriseSwiper',
      meta: {
        title: '图片展示'
      },
      component: () => import('../views/enterprise/swiper.vue')
    },
    {
      path: 'process',
      name: 'process',
      meta: {
        title: '流程视窗'
      },
      component: Process,
      redirect: '/process/processProject',
      children:[
        {
          path: 'processProject',
          name: 'processProject',
          meta: {
            title: '项目流程'
          },
          component: () => import('../views/process/project.vue')
        },
        {
          path: 'processFlow',
          name: 'processFlow',
          meta: {
            title: '内部流程'
          },
          component: () => import('../views/process/flow.vue')
        },
      ]
    },
    {
      path: 'processPdf',
      name: 'processPdf',
      meta: {
        title: '流程视窗'
      },
      component: () => import('../views/process/pdf.vue')
    },
    {
      path: 'processDocx',
      name: 'processDocx',
      meta: {
        title: '流程视窗'
      },
      component: () => import('../views/process/docx.vue')
    },
    {
      path: 'knowledge',
      name: 'knowledge',
      meta: {
        title: '知识云图'
      },
      component: () => import('../views/knowledge.vue')
    },
    {
      path: 'knowledgeTalk',
      name: 'knowledgeTalk',
      meta: {
        title: '知识云图'
      },
      component: () => import('../views/knowledge/talk.vue')
    },
    {
      path: 'supervision',
      name: 'supervision',
      meta: {
        title: '服务监督'
      },
      component: () => import('../views/supervision.vue')
    },
    {
      path: 'archive',
      name: 'archive',
      meta: {
        title: '档案跟踪'
      },
      component: () => import('../views/archive.vue')
    },
    {
      path: 'archiveTalk',
      name: 'archiveTalk',
      meta: {
        title: '档案跟踪'
      },
      component: () => import('../views/archive/talk.vue')
    },
    {
      path: 'agent',
      name: 'agent',
      meta: {
        title: '项目智能体'
      },
      component: () => import('../views/agent.vue')
    },
    {
      path: 'agentTalk',
      name: 'agentTalk',
      meta: {
        title: '项目智能体'
      },
      component: () => import('../views/agent/talk.vue')
    },
    {
      path: 'evaluate',
      name: 'evaluate',
      meta: {
        title: '服务评价'
      },
      component: () => import('../views/evaluate.vue')
    },
    {
      path: 'policy',
      name: 'policy',
      meta: {
        title: '政策要点'
      },
      component: () => import('../views/policy.vue')
    },
    {
      path: 'policyDetail',
      name: 'policyDetail',
      meta: {
        title: '政策要点'
      },
      component: () => import('../views/policy/detail.vue')
    },
    {
      path: 'policyPdf',
      name: 'policyPdf',
      meta: {
        title: '政策要点'
      },
      component: () => import('../views/policy/pdf.vue')
    },
    {
      path: 'project',
      name: 'project',
      meta: {
        title: '项目展示'
      },
      component: () => import('../views/project.vue')
    },
    {
      path: 'glb',
      name: 'glb',
      meta: {
        title: '项目展示'
      },
      component: () => import('../views/glb.vue')
    }]
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      title: 'demo'
    },
    component: () => import('../views/demo.vue')
  },
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  }
})
// 登录白名单
const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const token = store.getters.token
  if (whiteList.includes(to.path)) {
    // 已登录用户访问登录页，直接跳首页
    token ? next('/') : next()
  } else {
    // 需要登录的页面：无 token 跳登录页并记录回跳地址
    token ? next() : next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
})

export default router
